function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 18a6 6 0 00.66 8.46l11.399 9.75 7.8-9.12-11.4-9.75A6 6 0 0015 18z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "M3.525 39.109l9.75-11.4 7.6 6.5-9.75 11.4z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "M6.775 35.31l3.25-3.8 7.6 6.5-3.25 3.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.325 42.359l9.75-11.4"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "M24.325 14.79l9.75-11.398 7.599 6.5-9.75 11.399z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "M27.575 10.991l3.25-3.8 7.599 6.5-3.25 3.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.124 18.04l9.75-11.398"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.938 32.29l-7.8 9.12a6 6 0 017.8-9.12z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-49.459)",
  cx: -3.929,
  cy: 56.099,
  r: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.038 36.85l2.28 1.95m1.525 5.909c2.71-1.63 3.36-2.39 4.55-5.32m-3.57 8.79c3.771-2.038 5.777-4.27 7.15-8.36m3.611.394c-1.762 5.137-5.012 8.936-9.75 11.399"
}));

var SvgSatellite = function SvgSatellite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSatellite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Satellite.5fb4f1e7.svg";
export { ForwardRef as ReactComponent };